import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-47178ae6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "password_input_field" }

import { computed, ref, withDefaults } from 'vue'
import InputField from '@/components/atoms/InputField'
import IconButton from '@/components/molecules/IconButton'

type PropsType = {
  modelValue?: string
  klass?: string
  name?: string
  nameAs?: string
  placeholder?: string
  rule?: string
  setFocusState?: boolean
  isValid?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PasswordInputField',
  props: {
    modelValue: { default: '' },
    klass: null,
    name: null,
    nameAs: null,
    placeholder: { default: '' },
    rule: { default: 'required' },
    setFocusState: { type: Boolean, default: false },
    isValid: { type: Boolean, default: true }
  },
  emits: ["update:modelValue", "update:isValid"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:modelValue', inputValue: string): void
  (e: 'update:isValid', isValid: boolean): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { modelValue: string, klass?: string, name?: string, nameAs?: string, placeholder: string, rule: string, setFocusState: boolean, isValid: boolean };





const visiblePassword = ref(false)

const icon = computed<string>(() =>
  visiblePassword.value === false ? 'visibility' : 'visibility_off'
)

const iconColor = computed<string>(() =>
  props.klass === 'round_white' ? 'color-white' : 'color-dark3'
)

const inputValue = computed<string>({
  get: () => props.modelValue,
  set: (value) => {
    emit('update:modelValue', value)
  },
})

const isValidPassword = computed<boolean>({
  get: () => props.isValid,
  set: (value) => {
    emit('update:isValid', value)
  },
})

const toggleInputField = () => {
  visiblePassword.value = !visiblePassword.value
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (visiblePassword.value)
      ? (_openBlock(), _createBlock(_unref(InputField), {
          key: 0,
          modelValue: _unref(inputValue),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(inputValue) ? (inputValue).value = $event : null)),
          "is-valid": _unref(isValidPassword),
          "onUpdate:is-valid": _cache[1] || (_cache[1] = ($event: any) => (_isRef(isValidPassword) ? (isValidPassword).value = $event : null)),
          type: "text",
          klass: __props.klass,
          name: __props.name,
          "name-as": __props.nameAs,
          rule: __props.rule,
          "validate-on": "blur",
          placeholder: __props.placeholder,
          "set-focus-state": __props.setFocusState
        }, null, 8, ["modelValue", "is-valid", "klass", "name", "name-as", "rule", "placeholder", "set-focus-state"]))
      : (_openBlock(), _createBlock(_unref(InputField), {
          key: 1,
          modelValue: _unref(inputValue),
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(inputValue) ? (inputValue).value = $event : null)),
          "is-valid": _unref(isValidPassword),
          "onUpdate:is-valid": _cache[3] || (_cache[3] = ($event: any) => (_isRef(isValidPassword) ? (isValidPassword).value = $event : null)),
          type: "password",
          klass: __props.klass,
          name: __props.name,
          "name-as": __props.nameAs,
          rule: __props.rule,
          "validate-on": "blur",
          placeholder: __props.placeholder,
          "set-focus-state": __props.setFocusState
        }, null, 8, ["modelValue", "is-valid", "klass", "name", "name-as", "rule", "placeholder", "set-focus-state"])),
    _createVNode(_unref(IconButton), {
      icon: _unref(icon),
      "use-border": false,
      "icon-color": _unref(iconColor),
      class: "icon_button",
      onClick: toggleInputField
    }, null, 8, ["icon", "icon-color"])
  ]))
}
}

})